import { Mic, MicOff, MessageSquare, X, PauseCircle } from "lucide-react";

/**
 * VoiceControls — bottom row for mute, switch-to-text, and end-conversation.
 * Kept minimal by design — the primary interaction is your voice.
 */
export default function VoiceControls({
  muted, onToggleMute, onSwitchToText, onEnd,
  state, disabled = false,
}) {
  const isSpeaking = state === "speaking";
  return (
    <div className="voice-controls" data-testid="voice-controls">
      <button
        type="button"
        className={`voice-controls__btn voice-controls__btn--mute ${muted ? "is-active" : ""}`}
        onClick={onToggleMute}
        disabled={disabled}
        aria-pressed={muted}
        aria-label={muted ? "Unmute microphone" : "Mute microphone"}
        data-testid="voice-btn-mute"
      >
        {muted ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
        <span className="voice-controls__label">{muted ? "Unmute" : "Mute"}</span>
      </button>

      <button
        type="button"
        className="voice-controls__btn voice-controls__btn--pause"
        aria-label={isSpeaking ? "Pause AURI" : "Paused"}
        disabled
        data-testid="voice-btn-pause"
      >
        <PauseCircle className="h-5 w-5" />
        <span className="voice-controls__label">{isSpeaking ? "Speaking…" : "Idle"}</span>
      </button>

      <button
        type="button"
        className="voice-controls__btn voice-controls__btn--text"
        onClick={onSwitchToText}
        disabled={disabled}
        aria-label="Switch to text mode"
        data-testid="voice-btn-switch-text"
      >
        <MessageSquare className="h-5 w-5" />
        <span className="voice-controls__label">Switch to Text</span>
      </button>

      <button
        type="button"
        className="voice-controls__btn voice-controls__btn--end"
        onClick={onEnd}
        aria-label="End conversation"
        data-testid="voice-btn-end"
      >
        <X className="h-5 w-5" />
        <span className="voice-controls__label">End</span>
      </button>
    </div>
  );
}
